const baseURL = window.location.host;
const baseurl = window.location.pathname
let apiURL = "";
let BASE_HREF : string = "";
if (baseURL === 'localhost:4200'||baseURL === 'localhost:4201' || baseURL === '15.206.52.226:8040' || baseURL === 'dotnet.constient.com') {
      apiURL = "https://dotnet.constient.com/SBINRIDemoWebAPI/api/";
}
else if (baseURL === 'predigikyc.sbicapsec.com') {
    apiURL = "https://predigikyc.sbicapsec.com/SBINRI_WEBAPI/api/";
    BASE_HREF = '/SBINRI_DIY';
} else if (baseURL === 'preopendemataccount.sbicapsec.com') {
    apiURL = "https://preopendemataccount.sbicapsec.com/SBINRI_WEBAPI/api/";
} else if (baseurl === '/SBINRIDIY/register') {
    apiURL = "https://opendemataccount.sbisecurities.in/SBINRIWEBAPI/api/";
}
else {
    apiURL = "https://opendemataccount.sbisecurities.in/SBINRIWEBAPI/api/";
    BASE_HREF = '/SBINRIDIY';
}
export let environmentKey = "Cg$@DigiF!NS@thE";

export let environmentIV = "Cg$@DigiF!NS@thE";

export const environment = {
    production: false,
    ENVIRONMENT: {
        Key:environmentKey,
        Iv:environmentIV
    },
};


export const environmentUrls = {
    production: false,
    baseURls: {
        apiUrl:apiURL,
        href : BASE_HREF
    }
}